<h3 mat-dialog-title tabindex="0" class="semi-bold">{{ title | translate }}</h3>
<div mat-dialog-content>
  <div class="timeline-history-container">
    <div
      class="timeline-history-item"
      *ngFor="let event of events; let first = first; let last = last"
      [class.first]="first"
      [class.last]="last"
      [class.highlight-first-item]="highlightFirstItem"
      [class.hide-dot]="hideDot"
    >
      <div class="row row-gap--xs display-column-flex align-right justify-content-center">
        <div class="text-small color--navy bold">{{ event.changedOn | customFormat : TABLE_DATA_TYPE.StringDate}}</div>
        <div class="text-small color--dark-grey">{{ event.changedOn | customFormat : TABLE_DATA_TYPE.OnlyTimeDate}}</div>
      </div>

      <div class="timeline-history-marker">
        <div class="dot"></div>
      </div>

      <div class="row row-gap--xs display-column-flex py--sm">
        <div mat-button class="mat-mdc-button mdc-button non-clickable align-self-start" [ngClass]="getStatusClass(event.statusId)">
          <span class="mdc-button__label">
            {{ getMappedStatus(event.statusId) | translate }}
          </span>
        </div>
        <div class="text-xs color--dark-grey">Modified by: <b>{{ event.changedBy }}</b></div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row column--12 justify-content-center">
    <button mat-button class="secondary-button rounded" (click)="closeDialog()">
      {{ 'App.StatusHistory.Labels.Close' | translate }}
    </button>
  </div>
</div>
